import { Questionario } from "../../components/cadastro/questionario/Questionario";

export const QuestionarioPage = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Questionario />
        </div>
    )
}